import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import HorizontalMenuItem from './HorizontalMenuItem';
import { MenuItem } from '../../types';

const HorizontalList = styled('ul')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  width: '100%',
  height: 40,
  gap: '16px',
  '& > li': { margin: 0, padding: 0, display: 'flex', alignItems: 'center' },
});

interface HorizontalMenuListProps {
  menuItems: MenuItem[];
  onItemClick?: (item: MenuItem) => void;
  currentPath: string;
}

const HorizontalMenuList: React.FC<HorizontalMenuListProps> = ({ menuItems, onItemClick, currentPath }) => {
  const memoizedMenuItems = useMemo(
    () => menuItems.map((item, index) => (
      <HorizontalMenuItem
        key={item.id || item.label || index}
        item={item}
        onItemClick={onItemClick}
        currentPath={currentPath}
        level={0}
      />
    )),
    [menuItems, onItemClick, currentPath]
  );

  return <HorizontalList>{memoizedMenuItems}</HorizontalList>;
};

export default React.memo(HorizontalMenuList);
